import { render, staticRenderFns } from "./SbuTeaser.vue?vue&type=template&id=e4063838&scoped=true&"
import script from "./SbuTeaser.vue?vue&type=script&lang=js&"
export * from "./SbuTeaser.vue?vue&type=script&lang=js&"
import style0 from "./SbuTeaser.vue?vue&type=style&index=0&id=e4063838&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4063838",
  null
  
)

export default component.exports